module.exports = __webpack_public_path__ + "catalog/items/air-conditioner/air_conditioner.png";